// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"TagBanner_bannerContainer__rEKYb","unselectedTag":"TagBanner_unselectedTag__WvoIU","selectedTag":"TagBanner_selectedTag__qwTie","link":"TagBanner_link__A23Wc"};